<template>
  <div v-if="visible" class="modal-mask modal-transition">

    <div class="modal-container">

      <h1>List of landing pages</h1>
      <p v-if="this.validation"> Errors <span style="color: #c04545"> {{ this.validation }} </span></p>
      <table class="table table-striped child-row tableFixHead lp-table">
        <thead>
        <tr scope="row">
          <th scope="col">ID</th>
          <th scope="col">Landing Page Name</th>
          <th scope="col">Landing Page URL</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tr scope="row" :id="defineId(`defaultLpRowId`,lp.id)" v-for="(lp,index) in getLpOffers" :key="index">
          <td width="10%">
            <label class="lpID btn btn-secondary-">{{ lp.id }}
            </label>
          </td>
          <td width="30%">
            <input
                type="text"
                placeholder="ex: Movies Signup LP"
                class="condition__matches custom-input offerLpName"
                :id="defineId(`defaultLpName`, lp.id)"
                :value="lp.name"
                @change="updateLP($event,`name`, lp.id)"
                maxlength="30"
            >
          </td>
          <td width="60%">
            <textarea
                type="text"
                class="condition__matches custom-input offerLpUrl"
                :id="defineId(`defaultLpUrl`, lp.id)"
                :value="lp.url"
                @change="updateLP($event,`url`, lp.id)"
                maxlength="500"
            >
            </textarea>
          </td>
          <td width="10%">
            <b-button
                variant="light"
                @click="delLpOfferAction(lp.id)"
                :disabled="checkCanDelete(lp.id)"
                v-b-tooltip.hover.top="'Delete Custom LPs'"
                style="z-index:2">
              <i class="far fa-trash" data-fa-transform="shrink-1"></i>
            </b-button>

          </td>
        </tr>

        <tr>
          <td width="15%">
            <b-button variant="light" class="btn-add-line pull-left" @click="addLpOfferAction">
              <i class="far fa-plus"></i>
              Add LP
            </b-button>
          </td>
        </tr>
      </table>

      <h1 style="margin-top:30px">Custom landing pages per GEO</h1>
      <table class="table table-striped child-row tableFixHead lp-table">
        <thead>
        <tr scope="row">
          <th scope="col">GEO</th>
          <th scope="col">Landing Page</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tr scope="row" :id="defineId(`customLpRowId`,rules.pos)" v-for="(rules,index) in getCustomLPRules_()"
            :key="index">
          <td style="width: 25%; vertical-align: bottom;">
            <span class="hidden">{{ JSON.stringify(rules) }}</span>
            <div class="condition-line1">
              <model-select
                  :options="getCountriesModify()"
                  :id="defineId(`customCountry`,rules.pos)"
                  :value="rules.country"
                  @input="updateCustomLPAction($event, `country`, rules)"
                  class="condition__country condition__matches custom-select"
                  autocomplete="disable"
              >
              </model-select>
            </div>

          </td>
          <td style="width: 60%; vertical-align: bottom;">
            <span style="display: block; width: 100%; height: 21px;"></span>
            <div class="condition-line1">
              <model-select
                  :options="getLpModify()"
                  :id="defineId(`customLPs`,rules.pos)"
                  placeholder="Search landing page..."
                  @input="updateCustomLPAction($event, `id`, rules)"
                  :value="rules.id"
                  autocomplete="disable"
              >
              </model-select>
            </div>
          </td>
          <td style="width: 5%; vertical-align: bottom;">
            <span style="display: block; width: 100%; height: 21px;"></span>
            <b-button variant="light" @click="delCustomLpAction(rules.pos)"
                      v-b-tooltip.hover.top="'Delete Custom LPs'"
                      style="z-index:2">
              <i class="far fa-trash" data-fa-transform="shrink-1"></i>
            </b-button>
          </td>
        </tr>

        <b-button variant="light" class="btn-add-line pull-left" @click="addCustomLpAction">
          <i class="far fa-plus"></i> Add GEO
        </b-button>
      </table>

      <b-row class="text-center">
        <b-col cols="12">
          <button type="button" class="btn btn-cancel btn-secondary pull-left" @click="close"
                  style="margin-right: 20px;">Cancel
          </button>
          <button type="button" class="btn btn-savebucket btn-primary pull-right" @click="saveCustomLP(customLPRules)"
                  style=" font-size: 11px; padding: 10px 40px; margin-left: 20px">SAVE
          </button>
        </b-col>
      </b-row>

      <div class="modal-footer">
      </div>

    </div>
  </div>

</template>

<script>
import {ModelSelect} from 'vue-search-select'
import {mapGetters, mapMutations} from 'vuex'
import {isValidUrl} from '../../../../helpers'

export default {
  data() {
    return {
      visible: false,
      editMode: false,
      segmentId: 0,
      weight: 0,
      lpId: 0,
      id: 0,
      validation: '',
    }
  },
  props: ['defaultLp', 'customLPId', 'customLPRules'],
  components: {ModelSelect},
  computed: {
    ...mapGetters('countries', ['getCountries']),
    ...mapGetters('lpOffers', ['getLpOffers']),
    ...mapGetters('offer', ['getCustomLPRules'])
  },
  methods: {
    ...mapMutations('lpOffers', ['preSaveLpOffer', 'cancelLpOffer']),
    ...mapMutations('offer', ['changeGeo',
      'updOffer',
      'allowAll',
      'banAll',
      'addCustomLP',
      'delCustomLP',
      'updateCustomLP',
      'preSaveCustomLP',
      'cancelCustomLP'
    ]),
    ...mapMutations('countries', ['filterCountry']),
    ...mapMutations('lpOffers', ['addLpOffers', 'delLpOffers', 'updLpOffers']),
    getLpModify() {
      return this.getLpOffers.map(item => {
        item.value = item.id
        item.text = item.name + ' (' + item.id + ') '
        return item
      })
    },
    updateLP(event, field, id) {
      try {
        if (field === 'name') {
          const elLpName = document.querySelector(`#defaultLpName-${id}`);
          if (event.target.value !== '') {
            elLpName.style.background = null;
          } else {
            elLpName.style.background = '#f3b6b6';
          }
        }

        if (field === 'url') {
          const elLpUrl = document.querySelector(`#defaultLpUrl-${id}`);
          let url = event.target.value.trim(); // Убираем лишние пробелы

          let prefixHttp = 'http://';
          let prefixHttps = 'https://';

          if (!url.startsWith(prefixHttp) && !url.startsWith(prefixHttps)) {
            event.target.value = `${prefixHttp}${url}`;
            url = event.target.value;
          }

          const hasTemplateVariables = /{.*}/.test(url);

          if (!hasTemplateVariables) {
            try {
              const domain = new URL(url);
              if (isValidUrl(domain.origin)) {
                elLpUrl.style.background = null;
              } else {
                elLpUrl.style.background = '#f3b6b6';
              }
            } catch (error) {
              elLpUrl.style.background = '#f3b6b6';
            }
          } else {
            elLpUrl.style.background = null;
          }
        }

        let obj = {
          id: id,
          field: field,
          value: event.target.value.replace(/\s/g, '')
        };

        console.log('obj', obj);
        this.updLpOffers(obj);
        this.validation = this.checkLpUrls() || this.checkLpNames();
      } catch (e) {
        console.error('updateLPError', e);
      }
    },
    addCustomLpAction() {
      this.addCustomLP()
    },
    addLpOfferAction() {
      this.addLpOffers(this.customLPId)
    },
    delLpOfferAction(id) {
      this.delLpOffers(id)
      this.validation = this.checkLpUrls() || this.checkLpNames()
    },
    checkCanDelete(id) {
      if (!this.customLPRules) return
      let check = this.customLPRules.customLPRules.map(i => i.id)
      return check.includes(id)
    },
    delCustomLpAction(position) {
      this.delCustomLP(position)
    },
    getCustomLPRules_() {
      let customLPRulesRecords = this.customLPRules
      return customLPRulesRecords && customLPRulesRecords.customLPRules || []
    },
    getCountriesModify() {
      return this.getCountries.map(item => {
        item.value = item.code
        item.text = item.name + ' (' + item.code + ') '
        return item
      })
    },
    updateCustomLPAction(value, field, rules) {
      if (field === 'country') {
        let customLPRules = this.getCustomLPRules
        let customLPRulesValidateDuplicate = customLPRules.filter(i=>(i.lpUrl === rules.lpUrl && i.country === value ))
        if (customLPRulesValidateDuplicate.length !==0){
          alert(`Duplicate country:${customLPRulesValidateDuplicate[0].country} and site:${customLPRulesValidateDuplicate[0].lpUrl}`)
          return
        }

        if (value !== '') {
          let elCustomCountry = document.querySelector(`#customCountry-${rules.pos}`).parentNode
          elCustomCountry.style.background = null
        }
      }
      if (field === 'id') {
        let customLPRules = this.getCustomLPRules
        let customLPRulesValidateDuplicate = customLPRules.filter(i=>(i.country === rules.country && i.id === value ))
        if (customLPRulesValidateDuplicate.length !==0){
          alert(`Duplicate country:${customLPRulesValidateDuplicate[0].country} and site:${customLPRulesValidateDuplicate[0].lpUrl}`)
          return
        }
        if (value !== '') {
          let elCustomLp = document.querySelector(`#customLPs-${rules.pos}`).parentNode
          elCustomLp.style.background = null
        }
      }

      let updateFieldData = {}
      updateFieldData.value = value
      updateFieldData.field = field
      updateFieldData.position = rules.pos
      this.updateCustomLP(updateFieldData)
      if (field === 'id') {
        let lpName = this.getLpOffers.filter(item => (item.id === value))
        updateFieldData.field = 'lpName'
        updateFieldData.value = lpName[0].name
        this.updateCustomLP(updateFieldData)
        updateFieldData.field = 'lpUrl'
        updateFieldData.value = lpName[0].url
        this.updateCustomLP(updateFieldData)
      }
      this.validation = this.checkCustomLpCountry() || this.checkCustomLpUrl()

    },
    defineId(name, id) {
      this.disableAutocomplete(`${name}-${id}`)
      return `${name}-${id}`
    },
    disableAutocomplete(id) {
      let addAtr = document.getElementById(id);
      if (addAtr) {
        addAtr.setAttribute('autocomplete', 'disable');
      }
    },
    show(id) {
      this.visible = true
    },
    checkLpUrls() {
      const validationLp = this.getLpOffers
      const checkLpUrls = validationLp.filter(item => {
        const domain = new URL(item.url);
        return !(isValidUrl(domain.origin))
      })
      const listBrokenUrls = checkLpUrls.map(i => i.url).join(',')
      return listBrokenUrls ? `You have entered an invalid site name:${listBrokenUrls}` : ''
    },
    checkLpNames() {
      let validationLp = this.getLpOffers
      let checkLpNames = validationLp.filter(item => (
          item.name === ''
      ))
      return checkLpNames.length !== 0 ? 'Some landing page names is empty' : ''
    },
    checkCustomLpCountry() {
      let customLPRules = this.getCustomLPRules
      let validationCustomLpCountry = customLPRules.filter(item => (item.country === ''))
      return validationCustomLpCountry.length !== 0 ? 'Custom landing page country is missing' : ''
    },
    checkCustomLpUrl() {
      let customLPRules = this.getCustomLPRules
      let validationCustomLpUrl = customLPRules.filter(item => (item.lpUrl === ''))
      return validationCustomLpUrl.length !== 0 ? 'Custom landing page url is missing' : ''
    },
    saveCustomLP(data) {
      let customLPRules = this.getCustomLPRules
      let validationLp = this.getLpOffers
      let validationCustomLpCountry = customLPRules.filter(item => (item.country === ''))
      let validationCustomLpUrl = customLPRules.filter(item => (item.lpUrl === ''))
      let checkLpNames = validationLp.filter(item => (item.name === ''))

      const checkLpUrls = validationLp.filter(item => {
        const domain = new URL(item.url);
        return !(isValidUrl(domain.origin))
      })

      if (validationLp.length === 0) {
        this.validation = 'Input at least on Landing Page'
        return
      }
      if (validationCustomLpCountry.length !== 0) {
        validationCustomLpCountry.forEach(item => {
          let elCustomCountry = document.querySelector(`#customCountry-${item.pos}`).parentNode
          elCustomCountry.style.background = '#f3b6b6'
        })
        this.validation = this.checkCustomLpUrl()
        return;
      }

      if (validationCustomLpUrl.length !== 0) {
        validationCustomLpUrl.forEach(item => {
          let elCustomCountryUrl = document.querySelector(`#customLPs-${item.pos}`).parentNode
          elCustomCountryUrl.style.background = '#f3b6b6'
        })
        this.validation = this.checkCustomLpCountry()
        return;
      }

      if (checkLpNames.length !== 0) {
        checkLpNames.forEach(item => {
          document.querySelector(`#defaultLpName-${item.id}`).style.background = '#f3b6b6'
        })
        this.validation = this.checkLpNames()
        return;
      }

      if (checkLpUrls.length !== 0) {
        checkLpUrls.forEach(item => {
          document.querySelector(`#defaultLpUrl-${item.id}`).style.background = '#f3b6b6'
        })
        this.validation = this.checkLpUrls()
        return;
      }

      this.validation = ''
      this.preSaveCustomLP()
      this.preSaveLpOffer()
      this.visible = false
      this.$dialog.info({
        text: `Custom LP Saved`,
        title: 'LP'
      })
    },
    close() {
      this.visible = false
      this.cancelCustomLP()
      this.cancelLpOffer()
    },
  }
}
</script>


<style lang="sass">

.modal-mask
  position: fixed
  z-index: 9998
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  background-color: rgba(0, 0, 0, .7)
  transition: opacity .3s ease
  display: flex
  align-items: center
  justify-content: center


  .modal-container
    min-width: 60vw
    max-width: 60vw
    max-height: 80vh
    padding: 30px 30px 0px 30px
    background: #fff
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
    transition: all .3s ease
    overflow: auto

  .modal-body
    margin: 20px 0

  .modal-enter,
  .modal-leave
    opacity: 0

  .modal-enter .modal-container,
  .modal-leave .modal-container
    transform: scale(1.1)

  #table-wrapper
    position: relative

  #table-scroll
    height: 220px
    overflow: auto
    padding: 15px
    border: 2px solid #E3EEF4
    border-radius: 7px
    min-height: 215px
    margin-top: 15px

  #table-wrapper table
    width: 100%

  #table-wrapper table *
    background: yellow
    color: black

  #table-wrapper table thead th .text
    position: absolute
    top: -20px
    z-index: 2
    height: 20px
    width: 35%
    border: 1px solid red

  .table th, .table td
    color: #7F98A5
    font-size: 16px
    font-weight: 600
    letter-spacing: 0.3px
    padding: 0.8rem 1rem 0.5rem 0rem
    vertical-align: middle
    border-top: 0px

  tr:nth-child(even), .table-striped tbody tr:nth-of-type(even)
    background: rgba(227, 238, 244, 0)

  label.conversionType.btn.btn-secondary-, label.lpID.btn.btn-secondary-
    margin-bottom: 0
</style>
